import { FC } from 'react';

import type { ButtonModel } from '../../../types';
import BoxButton from '../../Button/Box';
import StickyBottomButton from '../../Button/StickyBottom/StickyBottomButton';
import StickyBottomButtonWrapper from '../../Button/StickyBottom/Wrapper';

type Props = Omit<ButtonModel, 'size' | 'icon' | 'color'> & {
  isInputFocused: boolean;
};

const StickyKeyboardButton: FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ isInputFocused, ...props }) => {
  return !isInputFocused ? (
    <StickyBottomButtonWrapper className="page-padding">
      <StickyBottomButton {...props} />
    </StickyBottomButtonWrapper>
  ) : (
    <div className="fixed left-0 right-0 bottom-0">
      <BoxButton forStickyKeyboard {...props} />
    </div>
  );
};

export default StickyKeyboardButton;
